import {
    useMutation
} from "react-query"
import httpClient from "./httpClient"

export const useRegister = () => {
    return useMutation(payload => {
        return httpClient.post('/wishwash/register', payload)
    })
}